import { configureStore } from '@reduxjs/toolkit';
import manorReducer from '../pages/manor/manorSlice';

export const store = configureStore({
  reducer: {
    manor: manorReducer
  }
});
